/*** IMPORTS FROM imports-loader ***/


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};




//////////////////
// WEBPACK FOOTER
// ../~/es-to-primitive/helpers/isPrimitive.js
// module id = 159
// module chunks = 3